import React, { FC, useEffect, useState } from "react";
import PortalRegistrationCghs from "../../../../components/patient/Portal Registration/PortalRegistrationCghs";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import dayjs from "dayjs";
import PortalSubmissionModal from "../../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../../components/patient/PreAuth/ManuallyIdModal";
import PortalSubmitModal from "../../../../components/patient/PreAuth/PortalSubmitModal";
import {
  fetchStepperData,
  getVisitStageStates,
} from "../../../../models/preAuthSlice";
import {
  getBasicDetails,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import RightSidePreviewWindow from "../../../../components/modals/PreviewModalForDrawer";
import { submitId } from "../../../../apis/patientService";
import Loader from "../../../../utils/Spinners";
import ManuallyRegistrationIdPortal from "../../../../components/patient/PreAuth/ManuallyRegistrationIdPortal";
import { getPortalDataForAyushB } from "../../../../models/ayushmanBSlice";
import { registerPatientPortal } from "../../../../apis/ayushmanBService";
import PortalRegistrationAyushman from "../../../../components/patient/Portal Registration/Ayushman Bharat/PortalRegistrationAyushman";

type PortalRegistrationAyushmanContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const PortalRegistrationAyushmanContainer: FC<
  PortalRegistrationAyushmanContainerProps
> = ({ activeKey, sseData, sseUpdateCount }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth, ayushBPreAuth } = useSelector(
    (state: RootState) => state
  );
  const [editRegId, setEditRegId] = useState<boolean>(false);
  const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
    useState<boolean>(false);
  const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false); //open enter id manually
  const [manuallyRegistrationIdPortal, setManuallyRegistrationIdPortal] =
    useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const [previewDocument, setPreviewDocument] = useState<boolean>(false);
  const [cardDocumentUrl, setCardDocumentUrl] = useState<any>("");
  const [isFetchingDocuments, setIsFetchingDocuments] =
    useState<boolean>(false);
  const [showRegistrationId, setShowRegistrationId] = useState<boolean>(false);

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]))
  );

  const isPortalRegistrationTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    return (
      currentStage?.visitStage?.toUpperCase() ===
      "Portal registration"?.toUpperCase()
    );
  };

  const fetchStepperForStatus = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  useEffect(() => {
    if (patients) {
      form.setFieldsValue({
        beneficiaryId:
          ayushBPreAuth?.portalData?.beneficiaryId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.beneficiaryId ||
          patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
        registrationDate: ayushBPreAuth?.portalData?.registrationDate
          ? dayjs(ayushBPreAuth?.portalData?.registrationDate, dateFormat)
          : patients?.fetchBasicDetails?.visitInfoResponse?.doa
          ? dayjs(
              patients?.fetchBasicDetails?.visitInfoResponse?.doa,
              dateFormat
            )
          : null,
        registrationId: ayushBPreAuth?.portalData?.schemeRegistrationId,
      });
    }
  }, [patients?.fetchBasicDetails, ayushBPreAuth?.portalData]);

  const fetchPortalData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      const resp = await dispatch(
        getPortalDataForAyushB({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );

      if (getPortalDataForAyushB.rejected.match(resp)) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  const fetchVisitStageIds = async () => {
    if (currentActiveStage?.visitStageId) {
      const resp = await dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );

      if (getVisitStageStates.rejected.match(resp)) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  useEffect(() => {
    fetchPortalData();
    fetchVisitStageIds();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    currentActiveStage?.visitStageId,
  ]);

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPortalRegistrationTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
      // fetchDocuments();
    }
  }, [
    ayushBPreAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (
  //       patients?.fetchBasicDetails?.casesResponse?.id &&
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id
  //     ) {
  //       if (
  //         preAuth?.portalData?.schemeRegistrationId == null &&
  //         preAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //           "portal registration" &&
  //         preAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //           "initiated"
  //       ) {
  //         fetchPortalData();
  //       }
  //     }
  //   }, 10000);

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //   preAuth?.portalData,
  // ]);

  // useEffect(() => {
  //   let intervalId: NodeJS.Timeout | null = null;
  //   let timeoutId: NodeJS.Timeout | null = null;
  //   let pollCount = 0;
  //   const maxPolls = 24;
  //   const modifiedAt = ayushBPreAuth?.portalData?.modifiedAt;

  //   const modifiedTime = new Date(modifiedAt).getTime();
  //   const now = Date.now();
  //   const diffSeconds = (now - modifiedTime) / 1000;

  //   if (
  //     ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //       "portal registration" &&
  //     ayushBPreAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //       "initiated" &&
  //     !ayushBPreAuth?.portalData?.schemeRegistrationId &&
  //     diffSeconds <= 78
  //   ) {
  //     intervalId = setInterval(() => {
  //       pollCount++;
  //       if (
  //         patients?.fetchBasicDetails?.casesResponse?.id &&
  //         patients?.fetchBasicDetails?.visitInfoResponse?.id
  //       ) {
  //         fetchPortalData();
  //       }

  //       if (ayushBPreAuth?.portalData?.schemeRegistrationId) {
  //         if (intervalId) clearInterval(intervalId);
  //         if (timeoutId) clearTimeout(timeoutId);
  //       }

  //       if (pollCount >= maxPolls) {
  //         if (intervalId) clearInterval(intervalId);
  //         setShowRegistrationId(true);
  //         // form.setFieldValue("registrationId", "-");
  //       }
  //     }, 5000);

  //     timeoutId = setTimeout(() => {
  //       if (intervalId) clearInterval(intervalId);
  //       setShowRegistrationId(true);
  //       // form.setFieldValue("registrationId", "-");
  //     }, 120000);
  //   }
  //   else if (
  //     ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //       "portal registration" &&
  //     ayushBPreAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //       "initiated" &&
  //     !ayushBPreAuth?.portalData?.schemeRegistrationId &&
  //     diffSeconds > 78
  //   )  {
  //     setShowRegistrationId(true);
  //   }
  //   else if (
  //     ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase()?.toString() ==
  //       "portal registration" &&
  //     ayushBPreAuth?.portalData?.stateName?.toLowerCase()?.toString() ==
  //       "manually submitted" &&
  //     !ayushBPreAuth?.portalData?.schemeRegistrationId
  //   )  {
  //     setShowRegistrationId(true);
  //   }

  //   return () => {
  //     if (intervalId) clearInterval(intervalId);
  //     if (timeoutId) clearTimeout(timeoutId);
  //   };
  // }, [
  //   patients?.fetchBasicDetails?.casesResponse?.id,
  //   patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //   ayushBPreAuth?.portalData?.modifiedAt,
  //   ayushBPreAuth?.portalData?.schemeRegistrationId,
  //   ayushBPreAuth?.portalData?.stateName,
  //   ayushBPreAuth?.portalData?.visitStagesName,
  // ]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );
    }
    await fetchPortalData();
    fetchStepperForStatus();
    await getTimelineDetail();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const handleEditRegId =  React.useCallback(() => {
    setEditRegId(!editRegId);
  }, []);

  const handleManuallyIdEnter = React.useCallback(() => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  }, []);

  const handleCancelPortal = React.useCallback(() => {
    setIsSubmittedOnPortal(false);
    setOpen(true);
  }, []);

  const handleCancelManuallyId =  React.useCallback(() => {
    setIsManuallyEnteredId(false);
  }, []);

  const handleOk = () => {
    setOpen(false);
  };

  const handleRegistrationCancel = () => {
    setOpen(false);
    setIsSubmittedOnPortal(false);
  };

  const handleRegistration =  React.useCallback(() => {
    // if (patients?.fetchBasicDetails?.casesResponse.integratedWithPortal) {
    //   setIsSubmittedOnPortal(true);
    // } else {
    //   setManuallyRegistrationIdPortal(true);
    // }
    setIsSubmittedOnPortal(true);
  }, []);

  const handleSaveManually = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const registrationFormValues = await form.validateFields();
        const updatedData = {
          ...registrationFormValues,
          registrationDate: null,
          manualRegistration: true,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsLoading(true);
        await registerPatientPortal(updatedData);
        successMessage("Registered Successfully");
        setIsLoading(false);
        setManuallyRegistrationIdPortal(false);
        setIsSubmittedOnPortal(false);
        await fetchPortalData();
        fetchStepperForStatus();
        await getTimelineDetail();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsLoading(false);
      setIsSubmittedOnPortal(false);
    }

    setIsManuallyEnteredId(false);
    setManuallyRegistrationIdPortal(false);
    setIsSubmittedOnPortal(false);
  };

  const handleSaveModalOption = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const registrationFormValues = await form.validateFields();
        const updatedData = {
          ...registrationFormValues,
          registrationDate: registrationFormValues?.registrationDate
            ? dayjs(registrationFormValues?.registrationDate).format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          isCghs:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "CGHS"
              ? true
              : false,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };
        setIsLoading(true);
        await registerPatientPortal(updatedData);
        successMessage("Registered Successfully");
        setIsLoading(false);
        await fetchPortalData();
        await getTimelineDetail();
        await fetchStepperForStatus();
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
    } catch (err: any) {
      if (err.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsLoading(false);
    }
    setOpen(false);
  };

  // const fetchDocuments = async () => {
  //   if (
  //     patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
  //     patients?.fetchBasicDetails?.casesResponse?.id &&
  //     patients?.fetchBasicDetails?.visitInfoResponse?.id
  //   ) {
  //     try {
  //       setIsFetchingDocuments(true);
  //       const AllDocumentList = await getAllStarhealthDocumentsData(
  //         patients?.fetchBasicDetails?.casesResponse?.id,
  //         patients?.fetchBasicDetails?.visitInfoResponse?.id,
  //         patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
  //       );
  //       const cardUrl = AllDocumentList?.["PreAuth"]?.find(
  //         (document: any) => document.label?.toUpperCase() === "CGHS CARD"
  //       );
  //       setCardDocumentUrl(cardUrl?.documentList?.[0]?.documentUrl);
  //       setIsFetchingDocuments(false);
  //     } catch (err) {
  //       errorMessage("Please, Try again after sometime");
  //       setIsFetchingDocuments(false);
  //     }
  //   }
  // };

  const handleSubmitId = async (values: any) => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
      ) {
        const formData = {
          registrationId: values.registrationId,
          claimId: null,
        };
        const submitData = await submitId(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          formData
        );
        if (submitData) {
          if (editRegId) {
            successMessage("Registration Id updated successfully");
          } else {
            successMessage(
              "Registration is Successful, Please Proceed further"
            );
          }
          setEditRegId(false);
          await fetchPortalData();
          fetchStepperForStatus();
        }
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };

  const handlePreviewDocument = React.useCallback(() => {
    setPreviewDocument(true);
  }, []);

  return (
    <>
      {ayushBPreAuth?.isFetchingData ? (
        <Loader />
      ) : (
        <PortalRegistrationAyushman
          editRegId={editRegId}
          handleEditRegId={handleEditRegId}
          handleSubmitId={handleSubmitId}
          handleRegistration={handleRegistration}
          form={form}
          portalData={ayushBPreAuth?.portalData}
          handlePreviewDocument={handlePreviewDocument}
          cardDocumentUrl={cardDocumentUrl}
          showRegistrationId={showRegistrationId}
        />
      )}

      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Is Registration Already Submitted on Portal?"}
        handleCancel={handleCancelPortal}
        handleSave={handleManuallyIdEnter}
      />
      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Registration Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />
      <PortalSubmitModal
        open={isSubmittedOnPortal}
        title={"Do You want to Register PreAuth?"}
        handleOk={() => setIsSubmittedOnPortal(false)}
        handleCancel={() => setIsSubmittedOnPortal(false)}
        handleSave={handleSaveManually}
        isLoading={isLoading}
      />

      <RightSidePreviewWindow
        key={cardDocumentUrl}
        documentUrl={cardDocumentUrl}
        handleCancel={() => setPreviewDocument(false)}
        open={previewDocument}
        setOpen={setOpen}
        // wrapperRef={wrapperRef}
      />

      <ManuallyRegistrationIdPortal
        open={manuallyRegistrationIdPortal}
        title={"Enter Registration Id"}
        handleCancel={() => setManuallyRegistrationIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading}
      />
    </>
  );
};

export default PortalRegistrationAyushmanContainer;
